import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const currentUser = localStorage.getItem('currentUser');
        if (currentUser && localStorage.getItem('accessToken')) {
            request = request.clone({
                setHeaders: {
                    Authorization: localStorage.getItem('accessToken')
                }
            });
        }

        return next.handle(request);
    }
}
